import { FC, useState } from 'react';
import { DrillDownForm } from './DrillDownForm';
import { Button } from '../Form/Button';
import AccordionPanel from '../Accordion/AccordionPanel';
import { PlusCircleIcon, XCircleIcon } from '@heroicons/react/16/solid';
import { useDiagramStore } from '@diagram/ui/hooks/diagram-store.hook';
import { DrillDownId } from '@diagram/model/drilldown.model';

interface DrillDownItemProps {}

const CreateDrillDownItem: FC<DrillDownItemProps> = () => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const setActiveDrillDown = useDiagramStore(
    (s) => s.drilldown.setActiveDrilldown
  );

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>): void => {
    event.preventDefault();
    if (isOpen) {
      setActiveDrillDown('' as DrillDownId);
    }
    setIsOpen((prev) => !prev);
  };

  return (
    <li className="w-full block bg-gray-50 rounded">
      <div className="border border-gray-300 rounded-lg shadow-md w-full">
        <Button
          type="button"
          variant={isOpen ? 'closeDrillDown' : 'createDrillDown'}
          onClick={handleClick}
        >
          {isOpen ? (
            <XCircleIcon className="h-5 w-5" />
          ) : (
            <>
              <PlusCircleIcon className="h-5 w-5" />
              Create DrillDown
            </>
          )}
        </Button>
        <AccordionPanel isOpen={isOpen} overrideClasses="">
          <DrillDownForm setIsOpen={setIsOpen} />
        </AccordionPanel>
      </div>
    </li>
  );
};

export default CreateDrillDownItem;
